import { Order } from '@weave/schema-gen-ts/dist/schemas/forms-digital/forms_messages.pb';
import { createProvider } from '@frontend/store';
import { FormsSubmissionV2Store } from './types';

export const { Provider: FormsSubmissionV2StoreProvider, useStore: useFormsSubmissionV2Store } =
  createProvider<FormsSubmissionV2Store>()((set) => ({
    searchValue: '',
    setSearchValue: (searchValue) => set({ searchValue }),

    filterByDate: undefined,
    setFilterByDate: (dateFrom) => set({ filterByDate: dateFrom }),

    sortOrder: Order.DESC,
    setSortOrder: (sortOrder) => set({ sortOrder }),
  }));
